require('aframe');
require('../index.js');



//////////////////
// WEBPACK FOOTER
// ./components/piechart/examples/main.js
// module id = 9
// module chunks = 0